import repository from '@/repositories/repository'

export default baseUrl => {

    baseUrl = `${baseUrl}/estorno-dispensacao`

    return {
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
    }
}